import { inject, Injectable, signal } from '@angular/core';
import { DevPortalHttpClient } from './dev-portal-http-client.service';
import { ToolType } from '../models/tool-type.model';
import { catchError, first, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToolTypeService {
  private readonly httpClient = inject(DevPortalHttpClient);

  private readonly _toolTypes = signal<ToolType[]>([]);
  readonly toolTypes = this._toolTypes.asReadonly();

  private readonly _isLoading = signal<boolean>(false);
  readonly isLoading = this._isLoading.asReadonly();

  loadToolTypes(forceRefresh = false): void {
    if (!forceRefresh && this._toolTypes().length > 0) {
      return;
    }

    this._isLoading.set(true);
    this.httpClient
      .Get<ToolType[]>('/tools/tool-types')
      .pipe(
        first(),
        tap(() => console.log('Fetching tool types')),
        catchError((error) => {
          console.error('Error fetching tool types:', error);
          this._isLoading.set(false);
          return of([]);
        })
      )
      .subscribe((types) => {
        this._toolTypes.set(types ?? []);
        this._isLoading.set(false);
      });
  }
}
